import React, { useCallback, useEffect, useRef, useState } from 'react';

import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';

import { FiUser } from 'react-icons/fi';
import { Root, Title, ColInput } from './styles';

import getValidationErrors from '../../../utils/getValidationErrors';

import Input from '../../../components/Input';
import Button from '../../../components/Button';
import CardAddress from '../../../components/CardAddress';
import { UserAddresses } from '../../../store/modules/auth/types';
import InputMask from '../../../components/InputMask';
import {
  customerCEPRequest,
  customerCEPClear,
  customerSaveAddrewssRequest,
} from '../../../store/modules/auth/actions';
import { StoreState } from '../../../store/createStore';
import { setIsCategory } from '../../../store/modules/parameter/actions';
import { useHistory } from 'react-router';
import { routesEndpoints } from '../../../routes/endpoint';

const AccountAddress: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const dispatch = useDispatch();
  const [postcode, setPostcode] = useState('');
  const history = useHistory();

  const { user, address } = useSelector((state: StoreState) => state.auth);

  useEffect(() => {
    if (user.addresses?.length) {
      history.push(routesEndpoints.NEW_CHECKOUT);
    }
  }, [user, history]);


  const handleSubmit = useCallback(
    async (data: UserAddresses) => {
      try {
        formRef.current?.setErrors({});
        const schema = Yup.object().shape({
          postcode: Yup.string()
            .required('CEP obrigatório')
            .min(9, 'No mínimo 6 digitos')
            .max(9, 'No maximo 6 digitos'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        if (address?.id && address?.id > 0) {
          data.id = address.id;
        }
        data.default_address = true;

        dispatch(customerSaveAddrewssRequest(data));
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          formRef.current?.setErrors(errors);
          //konsole.log('handleSubmit errors:', errors);
        } else {
          //konsole.log('handleSubmit error:', error);
        }
      }
    },
    [dispatch, address],
  );

  const handleCEPChange = useCallback(newState => {
    const { value, selection } = newState;

    if (selection.end === 9) {
      setPostcode(value);
    }

    return {
      value,
      selection,
    };
  }, []);

  useEffect(() => {
    dispatch(customerCEPClear());
    dispatch(setIsCategory(false));

    setTimeout(() => {
      if (postcode) dispatch(customerCEPRequest(postcode));
    }, 300);
  }, [dispatch, postcode]);

  useEffect(() => {
    if (formRef.current && address?.address) {
      //konsole.log('carrega...', address);
      formRef.current.setData({
        address_name: address.address_name,
        name: address.address_name,
        address: address.address,
        postcode: address.postcode,
        number: address.number,
        neighborhood: address?.neighborhood,
        complement: address.complement,
        state: address.state,
        city: address?.city,
      });
    }
  }, [address]);

  return (
    <Root>
      <Form
        ref={formRef}
        onSubmit={handleSubmit}
      >
        <Title>
          <span>Cadastro de endereço</span>
        </Title>
        <ColInput>
          <div style={{ marginBottom: '30px' }} />
        </ColInput>
        <ColInput>
          <InputMask
            mask="99999-999"
            //icon={FiUser}
            name="postcode"
            textLabel="CEP*"
            beforeMaskedValueChange={handleCEPChange}
            className="postcode"
          />
        </ColInput>

        <ColInput>
          <div style={{ marginBottom: '30px' }} />
        </ColInput>
        <ColInput>
          <Input
            icon={FiUser}
            name="name"
            placeholder="Nome do Endereço*"
          />
        </ColInput>

        <ColInput>
          <Input
            icon={FiUser}
            name="address"
            placeholder="Endereço/Logradouro.*"
          />
        </ColInput>

        <ColInput>
          <Input icon={FiUser} name="number" placeholder="Número*" />
          <Input
            icon={FiUser}
            name="complement"
            placeholder="Complemento"
          />
        </ColInput>

        <ColInput>
          <Input icon={FiUser} name="neighborhood" placeholder="Bairro*" />
          <Input icon={FiUser} name="city" placeholder="Cidade*" />
        </ColInput>

        <ColInput>
          <Input icon={FiUser} name="state" placeholder="Estado*" />
        </ColInput>
        <ColInput>
          <Button
            button={{ type: 'submit' }}
            atributes={{
              buttonType: 'primary',
              textColor: '#fff',
              textSize: '30px',
              borderColor: '#dddddd',
            }}
          >
            Salvar
          </Button>
        </ColInput>
      </Form>

      <CardAddress title="Meus endereços" nobtnNew />
    </Root>
  );
};

export default AccountAddress;
